<section class="login-background">
  <app-pattern></app-pattern>
  <mat-card appearance="outlined" class="login-card">
    <app-loader [loading]="!utilService.translationsLoaded || isAuthLoading" [size]="32"></app-loader>
    <div *ngIf="utilService.translationsLoaded && !isAuthLoading" class="login-container">
      <app-compact-header></app-compact-header>
      <div class="heading-5">{{ 'general.api_login_title' | translate: {Default: viewService.conf.pageTitle} }}</div>
      <div *ngIf="!salespointRoleSelection">
        <div *ngIf="isIE">
          <div class="heading-5 text-primary">{{ viewService.conf.ieMessage | translate: {Default: viewService.conf.ieMessageDefault} }}</div>
        </div>
        <div class="message message-warning" *ngIf="hasTimeout && timeoutActive">
          <div>{{ 'general.api_users_user_is_locked' | translate }}</div>
          <b>{{ timeoutLeft }}</b>
        </div>
        <form *ngIf="!isIE" #loginForm="ngForm" class="flex flex-column" (ngSubmit)="login()" autocomplete="off">
          <mat-form-field appearance="outline" class="no-hint">
            <mat-label>{{'general.api_login_email' | translate}}</mat-label>
            <input matInput type="text" name="email" id="email" [(ngModel)]="email" required autocomplete="off">
          </mat-form-field>
          <mat-form-field appearance="outline" class="no-hint">
            <mat-label>{{'general.api_login_password' | translate}}</mat-label>
            <input matInput type="password" name="password" id="password" [(ngModel)]="password" required autocomplete="off">
          </mat-form-field>
          <mat-checkbox [(ngModel)]="remember" [ngModelOptions]="{standalone: true}">{{'general.api_login_remember' | translate}}</mat-checkbox>
          <button mat-flat-button color="primary" type="submit" [disabled]="!loginForm.form.valid || isLoading || (hasTimeout && timeoutActive)">
            <mat-spinner [diameter]="24" *ngIf="isLoading"></mat-spinner>
            <ng-container *ngIf="!isLoading">{{'general.api_login_to_bo' | translate}}</ng-container>
          </button>
          <button mat-button class="small" [routerLink]="['/forgot-password']" [queryParams]="{email: email}">
            {{'general.api_login_forgot' | translate}}
          </button>
          <ng-container *ngIf="viewService.conf.environment.length">
            <div class="top-spacer-x2 body-3">
              {{'general.api_login_register_account_title' | translate}}
            </div>
            <button mat-stroked-button color="primary" type="button" [disabled]="isLoading" [routerLink]="'/registration/user'">
              {{'general.api_general_register_account' | translate}}
            </button>
          </ng-container>
        </form>
      </div>
      <div *ngIf="salespointRoleSelection" class="salespoint-role-container">
        <div class="heading-5 medium">{{'general.api_log_in_as' | translate}}</div>
        <app-salespoint-role #salespointRoleComponent></app-salespoint-role>
        <button mat-flat-button color="primary" class="continue" [disabled]="!salespointRoleComponent.isValid || isLoading" (click)="salespointRoleComponent.switchRole(true); isLoading = true">
          <mat-spinner [diameter]="24" *ngIf="isLoading"></mat-spinner>
          <ng-container *ngIf="!isLoading">{{'general.api_login_continue' | translate}}</ng-container>
        </button>
        <button mat-stroked-button color="primary" (click)="logout()" [disabled]="isLoading">
          {{'general.api_login_logout' | translate}}
        </button>
      </div>
    </div>
    <div class="align-center version body-4">
      {{ viewService.version }}<ng-container *ngIf="!!viewService.conf.environment"> | {{ viewService.conf.environment }}</ng-container>
    </div>
  </mat-card>
</section>
